const Auth = {
  Login: '/login',
  Verify: '/verify',
  Signup: '/sign-up',
  Callback: '/auth/callback',
  SsoCallback: '/sso/callback',
  SelectVerify: '/select-verify',
  ForgotPassword: '/forgot-password',
  SsoIdpStartLogin: '/sso/idp/start-login',
};

const Dashboard = {
  Home: '/dashboard',
};

const AdditionalInfo = {
  Home: '/additional-info',
};

const Resources = {
  Home: '/resources',
};

const Course = {
  Form: '/forms/:id',
  Completed: '/completed',
  Resource: '/resources/:id',
};

const Profile = {
  Home: '/profile',
};

const ContactUs = {
  Home: '/contact-us',
};

export const Routes = {
  Auth,
  Course,
  Profile,
  Home: '/',
  Dashboard,
  Resources,
  ContactUs,
  AdditionalInfo,
  NotFound: '/404',
};
